export default "__VITE_ASSET__88b5072e__"